import classNames from 'classnames';
import { GlobalContext } from 'Context/GlobalContext/AppContext';
import { useContext } from 'react';
import api from 'services/api';
import './styles.scss';

const Pdf = ({ small, thumbnail, id, tipoDoc, title }) => {
    const { setPdfModal } = useContext(GlobalContext);

    const logoClass = classNames({
        pdf: true,
        'pdf--small': small,
    });

    return (
        <img
            src={`${api.getThumbnail(id, tipoDoc)}&${Date.now()}`}
            className={logoClass}
            alt="Thumbnail"
            onClick={
                () =>
                    setPdfModal({
                        isVisible: true,
                        url: api.getArquivo(id, tipoDoc),
                        title,
                    }) //Open visualization modal through Context - The true parameter refers to ignoreTab bypass download count
            }
        />
    );
};

export default Pdf;
